import { useTranslation } from "react-i18next";
import { Video } from "lucide-react";

/**
 * Empty state for the recordings tab — shown when a moderator opens the tab for
 * a chat that has no recordings yet.
 */
export default function RecordingsEmpty() {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col items-center justify-center gap-2 p-4">
      <Video className="size-8 text-muted-foreground" />
      <p className="text-center text-sm text-muted-foreground">
        {t("chatDetailsTabs.no_recordings")}
      </p>
    </div>
  );
}
